export default class MediaQuery {
  static init () {
    if (this.initialized) return this
    this.names.forEach(name => {
      const query = this.queries[name] = window.matchMedia(this.definitions[name])

      const fits = (other) => {
        return this.names.indexOf(other) <= this.names.indexOf(name)
      }

      if (query.matches) {
        this.current = { media: query.media, name, includes: this.includes(name), fits }
      }

      query.addListener(event => { // safari
        const { matches, media } = event

        if (matches) {
          this.current = { media, name, includes: this.includes(name), fits }
        }
      })
    })

    this.initialized = true
    return this
  }

  // private
  static includes (name) {
    const i = this.names.indexOf(name)
    return i >= 0 ? this.names.slice(0, i + 1) : []
  }

  static get current () {
    return this._current
  }

  static set current (value) {
    this._current = value

    this.listeners.forEach(listener => {
      listener(this.current)
    })
  }

  static addListener (callback) {
    this.listeners.push(callback)

    if (this.current.name) {
      callback(this.current)
    }
  }

  static removeListener (callback) {
    this.listeners.splice(this.listeners.indexOf(callback), 1)
  }

  static definitions = {
    small: '(min-width: 0) and (max-width: 48em)',
    medium: '(min-width: 48em) and (max-width: 64em)',
    large: '(min-width: 64em) and (max-width: 80em)',
    xlarge: '(min-width: 80em) and (max-width: 90em)',
    xxlarge: '(min-width: 90em)'
  }

  static names = Object.keys(this.definitions)

  static listeners = []
  static queries = {}
}

MediaQuery.current = {}
MediaQuery.init()
